module.exports = __webpack_public_path__ + "static/img/5.a2f2bebb.jpg";